import { COMPONENTS } from '../../../components/components.registry';
import { FacetsConfig, SLOTS } from '../../../models';
import { DeepPartial } from '../../../utils';

export const DEFAULT_FACETS_CONFIG: DeepPartial<FacetsConfig> = {
  default: {
    group: {
      components: {
        panel: COMPONENTS.PANELS.SidePanel
      },
      templateSlots: {
        panel: SLOTS.template.leftAside,
        toggle: SLOTS.template.toolbar
      },
      layoutDirection: 'vertical',
      collapsible: false,
      startCollapsed: false
    }
  }
};
